import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Button, Typography, Box } from '@mui/material';
import AssetsPage from 'components/assets/page/AssetsPage';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { addAssetToProductAPI } from 'api/OmsFactoryopsWebServices';


import { setMultiSelection } from 'store/slice/ImageGallerySlice';
import { addAssetsObj } from 'store/slice/ManufSlice';
import ImageGalleryHolder from 'core/components/image-gallery/ImageGalaryHolder';
import {setMfproductLinkAssetModal} from 'store/slice/ManufSlice';
import { setHolderHeight,setSelectedAssetIdList } from 'store/slice/ImageGallerySlice';

export default function LinkAssetActionImpl() {
    const dispatch = useDispatch();
    const { selectedAssetIdList, assetList } = useSelector((state) => state.imagegalleryslice);
    const { mfproductObj } = useSelector((state) => state.manufslice.mfproductDashboard);
    const [uploadError, setUploadError] = useState('');
    const {assetsList} = useSelector((state) => state.manufslice.assetsDashboard);

    useEffect(() => {
        dispatch(setMultiSelection(true));
        dispatch(setHolderHeight({lg:'52vh', md:'60vh', sm:'60vh', xs:'65vh', }));
    }, []);
    const handleUploadAssetList = () => {
        const selectedIds = selectedAssetIdList ? selectedAssetIdList.split(',').map(id => id.trim()).filter(Boolean) : [];
        const alreadyLinkedAssetIds = assetsList ? assetsList.map(a => String(a.damassetid)) : [];
        const assetsToLink = assetList
            ? assetList.filter(asset =>
                selectedIds.includes(String(asset.id)) && !alreadyLinkedAssetIds.includes(String(asset.id))
            )
            : [];

        assetsToLink.forEach(asset => {
            handleUploadAsset(asset);
        });

        dispatch(setSelectedAssetIdList(''))
        dispatch(setMfproductLinkAssetModal(false));
    }
    const handleUploadAsset = (asset) => {
        addAssetToProductAPI({
            productId: mfproductObj.id,
            assetPath: asset.path,
            assetId: asset.id,
            assetName: asset.name
        }, (apiResponse) => {
            
            dispatch(addAssetsObj(apiResponse.assetsInfo));
        }, (errorMessage) => {
            setUploadError(errorMessage || 'Error adding asset to product');
            console.error("Error adding asset to product:", errorMessage);
        });
    };
    
    return (
        <>
            <ImageGalleryHolder label="Continue" clickToAction={()=>handleUploadAssetList()}/>

        </>
    )
}